import { Box, Button, Switch, Typography } from '@mui/material';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { InfoTooltip } from '~/components/InfoTooltip/InfoTooltip';
import {
  isUnifiedAccountAccessButtonTooltip,
  isUnifiedAccountAccessTextTooltip,
} from '../constants';
import { styles } from './styles';
import { commonStyles } from '~/theme/styles/commonStyles';
import { selectIsReidentification } from '~/store/identification-form/selectors';

interface IUinfiedAccountAccessProps {
  handleDocumentTemplates: () => void;
}

const UnifiedAccountAccess = ({ handleDocumentTemplates }: IUinfiedAccountAccessProps) => {
  const isReidentification = useSelector(selectIsReidentification);
  const { setValue } = useFormContext();
  const isUnifiedAccountAccess = useWatch({ name: 'isUnifiedAccountAccess' });

  if (!isReidentification) return null;

  const isUnifiedAccountAccessText = isUnifiedAccountAccess
    ? 'Однаковий доступ до всіх рахунків'
    : 'Роздільний доступ до рахунків';

  const handleChangeIsUnifiedAccountAccess = (
    _: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue('isUnifiedAccountAccess', checked);
  };

  return (
    <Box sx={styles.container}>
      <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
        <Switch checked={isUnifiedAccountAccess} onChange={handleChangeIsUnifiedAccountAccess} />
        <Typography variant="body1">{isUnifiedAccountAccessText}</Typography>
        <InfoTooltip title={isUnifiedAccountAccessTextTooltip} />
      </Box>

      {!isUnifiedAccountAccess && (
        <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
          <Button variant="contained" onClick={handleDocumentTemplates}>
            Завантажити шаблон
          </Button>
          <InfoTooltip title={isUnifiedAccountAccessButtonTooltip} />
        </Box>
      )}
    </Box>
  );
};

export default UnifiedAccountAccess;
